import { resolveVoteAnonymization, VOTE_ANONYMIZATION } from "./vote-visibility";

// A guest may vote iff they are an anonymous Firebase user AND the scheduler is
// link-shared AND the scheduler is not locked (FINALIZED/CANCELLED). Mirrors
// the rules-layer `isLinkSharedGuestVoteAllowed` allowance. Real users go
// through the participant path (isAcceptedParticipant), not this gate.
export function canGuestVote({ user, scheduler, isLocked } = {}) {
  if (!user?.isAnonymous) return false;
  if (!scheduler?.allowLinkSharing) return false;
  if (isLocked) return false;
  return true;
}

// The name-entry card is shown before voting UNLESS the scheduler is fully
// anonymous (nobody will ever see the name) OR the guest already has an
// existing vote (editing flow — no need to re-ask).
export function shouldShowNameCard({ scheduler, existingVote } = {}) {
  if (existingVote) return false;
  return resolveVoteAnonymization(scheduler?.voteAnonymization) !== VOTE_ANONYMIZATION.ALL_PARTICIPANTS;
}

export const GUEST_NAME_MAX_LENGTH = 40;

// Validate a guest-supplied name. Trim; non-empty after trim; max 40 chars; no
// uniqueness check (spec §11). Returns { valid, value, error }.
export function validateGuestName(raw) {
  const value = String(raw ?? "").trim();
  if (!value) {
    return { valid: false, value: "", error: "Please enter a name to vote." };
  }
  if (value.length > GUEST_NAME_MAX_LENGTH) {
    return {
      valid: false,
      value,
      error: `Name must be ${GUEST_NAME_MAX_LENGTH} characters or fewer.`,
    };
  }
  return { valid: true, value, error: null };
}
